import { render, staticRenderFns } from "./PackItem.vue?vue&type=template&id=6958bb46&scoped=true&"
import script from "./PackItem.vue?vue&type=script&lang=js&"
export * from "./PackItem.vue?vue&type=script&lang=js&"
import style0 from "./PackItem.vue?vue&type=style&index=0&id=6958bb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958bb46",
  null
  
)

component.options.__file = "PackItem.vue"
export default component.exports